// src/api/website-api/web-category.js
import axios from "axios";

const WEB_CATEGORY_API =
  `${process.env.REACT_APP_API_POS_WITH_WEBSITE}/api/vendor/categories`;

const getLang = () => localStorage.getItem("lang") || "en";

const getLanguageHeaders = () => {
  const lang = getLang();
  return {
    "Accept-Language": lang,              // "en" or "ar"
    "Language-ID": lang === "ar" ? 4 : 1, // 4 for Arabic, 1 for English
  };
};

/**
 * Fetch categories for the CURRENT store
 * (Store-ID + Authorization like web-product.js)
 */
export const fetchWebCategories = async () => {
  const token =
    localStorage.getItem("token") || localStorage.getItem("authToken");
  const storeId = localStorage.getItem("storeId");

  const headers = {
    ...getLanguageHeaders(),
  };

  if (storeId) headers["Store-ID"] = storeId;
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await axios.get(WEB_CATEGORY_API, { headers });

  const data = res.data;

  const raw = Array.isArray(data?.data)
    ? data.data
    : Array.isArray(data)
    ? data
    : [];

  const flattened = [];

  raw.forEach((parent) => {
    // keep parent as a category (optional)
    if (parent.name) {
      flattened.push({
        ...parent,
        isParent: true,
      });
    }

    // add all subcategories as separate categories
    if (Array.isArray(parent.subcategories)) {
      parent.subcategories.forEach((sub) => {
        flattened.push({
          ...sub,
          parent_id: parent.category_id,
          isSubcategory: true,
        });
      });
    }
  });

  return flattened;
};
